import { atom } from '@reatom/framework'

import type { DelugeId } from '@root/entities/user-short'

export const userConnectionsFollowingsModal = atom<
  | {
      delugeId: DelugeId
      followings: number
    }
  | undefined
>(undefined, 'userConnectionsFollowingsModal')
